import axios from "axios";
import { useMutation, useQueryClient } from "react-query";

export const  useBulkAssignCases =({reportName}) => {
    //console.log(reportName);
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: async ({body, config}) => {
        return axios.post(`${process.env.REACT_APP_API_URI}BulkAssignTech`, body,config).then((res) => {
          if(res.data.error){
            throw new Error(res.data.message)
          }
          return res.data.status
        })
      },
      onSuccess: () => {
        queryClient.invalidateQueries(['workbench', reportName])
      }

    });
  }